import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { guardRegistry, registerDefaultGuards } from './guardRegistry'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  // ========== Auth Routes ==========
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { requiresAuth: false, title: 'Iniciar sesión' },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { requiresAuth: false, title: 'Crear cuenta' },
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/auth/VerifyEmailView.vue'),
    meta: { requiresAuth: true, title: 'Verificar correo' },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { requiresAuth: false, title: 'Recuperar contraseña' },
  },

  // ========== Dashboard ==========
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashboardView.vue'),
    meta: { requiresAuth: true, title: 'Mis Exámenes' },
  },

  // ========== Exam Detail ==========
  {
    path: '/exams/:classroomId',
    name: 'exam-detail',
    component: () => import('@/views/exams/ExamDetailView.vue'),
    meta: { requiresAuth: true, title: 'Detalle del examen' },
  },
  {
    // El parámetro identifica la PREGUNTA (2026-07-16). La vista acepta también
    // un id de respuesta como fallback (deep links viejos `/questions/:answerId`).
    path: '/exams/:classroomId/questions/:questionId',
    name: 'question-detail',
    component: () => import('@/views/exams/QuestionDetailView.vue'),
    meta: { requiresAuth: true, title: 'Detalle de pregunta' },
  },

  // ========== Download ==========
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/DownloadView.vue'),
    meta: { requiresAuth: true, title: 'Descargar App' },
  },

  // ========== Profile ==========
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/profile/ProfileView.vue'),
    meta: { requiresAuth: true, title: 'Mi Perfil' },
  },

  // ========== 404 ==========
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: 'Página no encontrada' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

registerDefaultGuards()

router.beforeEach(async (to, from, next) => {
  await guardRegistry.executeGuards(to, from, next)
})

router.afterEach((to) => {
  const title = to.meta.title as string | undefined
  document.title = title ? `${title} - Quizoteca` : 'Quizoteca - Portal del Estudiante'
})

export default router
